import { api } from "../api";

export const NotificacaoService = {
    listarNotificacoes: async (token, datIni, datFim) => {
        const response = await api.get(`/notificacoes?dataInicio=${datIni}&dataFim=${datFim}`, {
            headers: { "Authorization": `${token}` }
        });

        return response.data;
    },
    marcarLida: async (token, data = []) => {
        const response = await api.patch(`/notificacoes`, data, {
            headers: { "Authorization": `${token}` }
        });

        return response.data;
    }
}